<template>
  <div class="market">
    <div class="empty-market" v-if="this.products.length===0 && !showForm">
      <div class="empty-market-body">
        <div class="empty-market-tablet-image">
          <img src="../assets/images/life_icon_market_background2_.svg" />
        </div>
        <h4>RDS Market</h4>
        <div class="empty-market-message">{{emptyMarketMessage}}</div>
      </div>
      <!--<div class="empty-market-footer">
        <div class="empty-market-button">
          <span>Torna alla Home</span>
        </div>
      </div>-->
    </div>
    <div id="market-box" v-if="this.products.length && !!!currentProduct && !showForm">
      <div class="market-evidenza">
        <div
          class="evidenza-img"
          v-bind:style="{backgroundImage: 'url('+prodottoInEvidenza.photos[0]+')'}"
        ></div>
        <div class="evidenza-container" v-on:tap="viewProduct(prodottoInEvidenza)">
          <div class="evidenza-header">
            <span class="span-evidenza">IN EVIDENZA</span>
            <i class="rds-icon rds-icon-more"></i>
          </div>
          <div class="grow"></div>
          <div>
            <h3>{{ prodottoInEvidenza.title }} - {{ prodottoInEvidenza.price}}€</h3>
            <div class="evidenza-date">{{ prodottoInEvidenzaDate }}</div>
          </div>
        </div>
      </div>

      <div id="label-box" v-if="!userParam">
        <div
          v-on:tap="changeTab(3);"
          class="market-list-tab"
          v-bind:class="{ selected : tab === 3}"
        >
          <p>Prodotti in vendita</p>
        </div>
        <!--        <div v-on:tap="changeTab(1)" class="market-list-tab" v-bind:class="{ selected: tab === 1}">
          <p>Popolari</p>
        </div>-->
        <div v-on:tap="changeTab(4);" class="market-list-tab" v-bind:class="{ selected: tab === 4}">
          <p>I miei prodotti</p>
        </div>
      </div>
      <div v-masonry id="sale-box" item-selector=".item-box" v-if="!updating">
        <div v-masonry-tile class="item-box" v-for="item in filteredProducts" v-bind:key="item.id">
          <div class="item">
            <img v-on:tap="viewProduct(item)" v-bind:src="item.photos[0]" />

            <i
              v-bind:class="{'user-like':userLike(item)}"
              v-on:tap.stop="toggleLike(item)"
              class="rds-icon rds-icon-cuore"
            ></i>
            <!-- <img class="cuore" src="../assets/images/cuore.svg" /> -->
          </div>
        </div>
      </div>
    </div>
    <MarketForm v-bind:product="productToEdit" v-on:newProduct="productAdded" v-if="showForm"></MarketForm>
    <MarketItem
      v-if="currentProduct"
      v-on:productRemove="productRemoved"
      v-on:editProduct="editProduct"
      v-bind:product="currentProduct"
    ></MarketItem>
  </div>
</template>

<script>
import enums from '../enums/RdsLife.enums';
import userService from '../services/User.service';
import store from '../stores';
import MarketItem from '../components/MarketItem';
import MarketForm from '../components/MarketForm';
import { eventBus } from '../services/EventBus';
import RestStore from '../stores/RestStore';
// import MarketProduct from '../models/marketProduct.model';

const restStore = new RestStore();
export default {
  name: 'rds-market',
  components: { MarketItem, MarketForm },
  data() {
    return {
      products: [],
      tab: 3,
      rand: Math.floor(Math.random() * 20) + 1,
      updating: false,
      currentProduct: null,
      showForm: false,
      userParam: null,
      productToEdit: null
    };
  },
  methods: {
    changeTab(tab) {
      this.tab = tab;
    },
    viewProduct(product) {
      this.currentProduct = product;
      eventBus.$emit('showBackButton');
      eventBus.$emit('hidePlusButton');
    },
    goTo(route) {
      this.$router.push(route);
    },
    backButtonClicked() {
      eventBus.$emit('showPlusButton');
      eventBus.$emit('hideBackButton');
      this.productToEdit = null;
      this.showForm = false;
      this.currentProduct = null;
    },
    productRemoved(productId) {
      this.products = this.products.filter(p => p.id !== productId);
      this.backButtonClicked();
    },
    editProduct(product) {
      console.log('product on product');
      console.log(product);
      this.productToEdit = product;
      this.currentProduct = null;
      this.showForm = true;
    },
    plusButtonClicked() {
      eventBus.$emit('hidePlusButton');
      eventBus.$emit('showBackButton');
      this.showForm = true;
    },
    toggleLike(product) {
      const added = userService.toggleLike('products', product.id);
      if (added) {
        product.likes.push(userService.user.id);
      } else {
        product.likes.splice(product.likes.indexOf(userService.user.id), 1);
      }
      store.update('marketProduct', product.id, product);
    },
    userLike(product) {
      return (
        Array.isArray(product.likes) &&
        product.likes.indexOf(userService.user.id) !== -1
      );
    },
    productAdded(product) {
      this.updating = true;
      eventBus.$emit('showPlusButton');
      eventBus.$emit('hideBackButton');
      eventBus.$emit('updating');
      this.productToEdit = null;
      this.showForm = false;
      if (product.id) {
        return this.productUpdated(product);
      }

      const photos = [];
      let uploadFilePromises = [];
      let getUrlPromises = [];
      let fileUtils = [];
      for (let i = 0; i < product.photos.length; i++) {
        const photo = product.photos[i];
        // const base64 = photo.base64;
        const file = photo.file;

        const filenamePart =
          Math.random()
            .toString(36)
            .substring(2, 15) +
          Math.random()
            .toString(36)
            .substring(2, 15);
        const filename =
          product.title
            .replace(/[^a-zA-Z ]/g, '')
            .replace(/s/g, '')
            .replace(/ /g, '')
            .toLowerCase() +
          '_' +
          filenamePart;
        // const mime = element.split(',')[0].match(/:(.*?);/)[1];
        // const file = dataURLtoFile(element, filename);
        photos.push(
          `https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/${filename}`
        );
        fileUtils.push({ file: file, mime: file.type, filename: filename });
        getUrlPromises.push(
          restStore.getUploadUrlPromiseResolve(file, file.type, filename)
        );
      }
      Promise.all(getUrlPromises).then(values => {
        for (let i = 0; i < values.length; i++) {
          const response = values[i];

          const util = fileUtils[i];
          uploadFilePromises.push(
            restStore.uploadFile(response.url, util.mime, util.file)
          );
        }
        Promise.all(uploadFilePromises).then(responses => {
          product.photos = photos;
          store
            .add('marketProduct', product)
            .then(p => {
              this.products.push(p);
              eventBus.$emit('updated');
              this.updating = false;
            })
            .catch(e => {
              console.warn(e);
              eventBus.$emit('updated');
              this.updating = false;
            });
        });
      });
    },
    productUpdated(product) {
      const vm = this;
      store.update('marketProduct', product.id, product).then(p => {
        const idx = this.products.findIndex(prod => prod.id === p.id);
        vm.products[idx] = p;
        eventBus.$emit('updated');
        vm.updating = false;
      });
    }
  },
  computed: {
    prodottoInEvidenzaDate() {
      try {
        let createdAt = this.prodottoInEvidenza.createdAt;
        let createdAtArr = createdAt.split('.');
        if (createdAtArr[0].length === 1) {
          createdAtArr[0] = '0' + createdAtArr[0];
        }
        if (createdAtArr[1].length === 1) {
          createdAtArr[1] = '0' + createdAtArr[1];
        }

        return createdAtArr.join('.');
      } catch (error) {
        console.warn(error);
        return this.prodottoInEvidenza.createdAt;
      }
    },
    emptyMarketMessage() {
      let message =
        'Al momento non ci sono prodotti presenti nello store. Torna a trovarci presto!';
      if (!!this.userParam) {
        message =
          'Al momento non hai prodotti in vendita nello store. Torna a trovarci presto!';
      }
      return message;
    },
    prodottoInEvidenza() {
      const prod = this.products.find(p => p.id === 85);
      return prod || this.products[0];
    },
    filteredProducts: function() {
      let fp;
      const withoutProdottoInEvidenza = this.products.filter(
        p => p.id !== this.prodottoInEvidenza.id
      );
      if (this.tab === enums.productPageViewModes.NOVITA) {
        fp = [].concat(withoutProdottoInEvidenza).reverse();
      } else if (this.tab === enums.productPageViewModes.POPOLARI) {
        fp = [].concat(withoutProdottoInEvidenza).sort((a, b) => {
          if (!Array.isArray(a.likes)) {
            a.likes = [];
          }
          if (!Array.isArray(b.likes)) {
            b.likes = [];
          }
          return b.likes.length - a.likes.length;
        });

        var min = Math.min(fp.length, maxPopular);
        fp = fp.slice(0, min);
      } else if (this.tab === enums.productPageViewModes.OFFERTE) {
        fp = [].concat(withoutProdottoInEvidenza).filter(p => p.forSale);
      } else if (this.tab === enums.productPageViewModes.TUTTI) {
        fp = [].concat(withoutProdottoInEvidenza).reverse();
      } else if (this.tab === enums.productPageViewModes.MIEI) {
        fp = []
          .concat(withoutProdottoInEvidenza)
          .filter(p => {
            return p.user.id === userService.user.id;
          })
          .reverse();
      }
      // setTimeout(() => {
      //   this.$redrawVueMasonry('sale-box');
      // }, 100);
      return fp;
    }
  },
  mounted() {
    eventBus.$emit('updating');
    const userId = this.$route.query.user;

    getProducts().then(products => {
      if (!!userId) {
        products = products.filter(
          p => p.user.id === userId || p.user.name === userService.user.name
        );
        this.userParam = userId;
      }
      this.products = products;
      if (this.products.length === 1) {
        this.currentProduct = this.products[0];
      }
      eventBus.$emit('showPlusButton');
      console.log('showPlusButton');
      eventBus.$emit('updated');
    });
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      console.log('Market back');
      this.backButtonClicked();
    });
    eventBus.$on('plusButtonClicked', () => {
      this.plusButtonClicked();
    });
    eventBus.$emit('showPlusButton');
  },
  destroyed() {
    eventBus.$emit('hidePlusButton');
    eventBus.$emit('hideBackButton');
    eventBus.$off('backButtonClicked');
    eventBus.$off('plusButtonClicked');
  }
};
let maxPopular = 5;
function getProducts() {
  return store.getAll(enums.modelTypes.MARKET_PRODUCT);
  // .then(resp => resp.json())
  // .then(response => response.data.Items)
  // .then(data => normalizeAwsData(data));
}
// function getProducts() {
//   return new Promise((resolve, reject) => {
//     const usersPromise = store.getAll('rdsUser');
//     usersPromise.then(users => {
//       // this.users = users;
//       restStore
//         .getAll(enums.modelTypes.MARKET_PRODUCT, 0)
//         .then(resp => resp.json())
//         .then(response => response.data.Items)
//         .then(data => normalizeAwsData(data))
//         .then(data => {
//           const prods = data.map(i => {
//             return new MarketProduct(i, { users: users });
//           });
//           resolve(prods);
//         });
//     });
//   });

//   // return restStore
//   //   .getAll(enums.modelTypes.MARKET_PRODUCT, 0)
//   //   .then(resp => resp.json())
//   //   .then(response => response.data.Items)
//   //   .then(data => normalizeAwsData(data));
// }
// function normalizeAwsData(data) {
//   return data.map(i => {
//     let content = i.content;
//     content.id = isNaN(Number(i.id)) ? i.id : Number(i.id);
//     return content;
//   });
// }

// function dataURLtoFile(dataurl, filename) {
//   const arr = dataurl.split(',');
//   const mime = arr[0].match(/:(.*?);/)[1];
//   const bstr = atob(arr[1]);
//   let n = bstr.length;
//   let u8arr = new Uint8Array(n);

//   while (n--) {
//     u8arr[n] = bstr.charCodeAt(n);
//   }

//   return new File([u8arr], filename, { type: mime });
// }
</script>
<style lang="scss">
.market.main {
  padding-bottom: 50px;
}
.empty-market {
  padding: 0 41px;
  background-image: url('../assets/images/life_market_background2.jpg');
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
}
.empty-market-img {
  padding: 20px 0;
  position: relative;
  .empty-market-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.empty-market-body {
  letter-spacing: $default-letter-spacing;
  color: #ffffff;
  flex-direction: row;

  h4 {
    margin: 0;
    font-size: 1.5em;
    text-align: center;
  }
  .empty-market-message {
    margin: 24px 0 30px;
    color: #ffffff;
    font-weight: 400;
    text-align: center;
    font-size: 15px;
    line-height: 1.5;
  }
}
.empty-market-button {
  background: #a31313;
  color: #ffffff;
  padding: 19px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  border-radius: $default-border-radius;
}
.market-evidenza {
  $heigth: 274px;
  // background-color: #e3e3e3;
  color: white;
  min-height: $heigth;
  max-height: $heigth;
  height: $heigth;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  letter-spacing: $default-letter-spacing;
  font-weight: 500;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  position: relative;

  .evidenza-img {
    position: absolute;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
    z-index: 0;
    &:after {
      content: '';
      background-image: url('../assets/images/gradient3.png');
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      opacity: 1;
      background-repeat: no-repeat;
      z-index: 0;
      background-position: bottom;
      background-size: cover;
    }
  }
  & > * {
    position: relative;
    z-index: 2;
  }
  .evidenza-container {
    padding: $default-padding;
    height: calc(100% - 42px);
    display: flex;
    flex-direction: column;
  }
  // padding: 20px;
  .evidenza-header {
    display: flex;
    // margin: 20px;
    .span-evidenza {
      background-color: $main-blue;
      color: white;
      padding: 10px 15px;
      font-size: 0.76em;
      border-radius: 5px;
    }
    .rds-icon-more {
      margin-left: auto;
    }
  }

  .grow {
    display: flex;
    margin: 25px;
    max-height: 200px;
  }

  h3 {
    font-size: 0.95em;
    letter-spacing: $default-letter-spacing;
    margin: 0;
    line-height: 20px;
    font-weight: 600;
  }
  .evidenza-date {
    font-size: 0.89em;
    margin-top: 3px;
  }
}

.rds-icon-cuore {
  color: white;
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 2em;
}
.user-like {
  color: #a21c20;
}
.market-list-tab {
  p {
    margin: 0;
    padding: 20px;
    font-weight: 500;
  }
}

.item-box {
  $margin: 10px;
  width: calc((100% - 85px) / 2);
  left: 0;
  margin: 0 $margin $margin 0;
}
.item {
  display: flex;
  display: inline-block;
}
.item img {
  width: 100%;
}

.market-list-tab {
  position: relative;
}

.market-list-tab {
  &:after {
    content: '';
    position: absolute;
    width: 0;
    // height: calc(100% - 4px);
    border-bottom: 2px solid #a31316;
    transition: all 0.2s linear;
    bottom: 0;
    left: 0;
    // transform: translateX(50%);
  }
  &.selected:after {
    width: 100%;
    transform: translateX(0);
  }
}

/* #market-box {
  display: flex;
  flex-direction: column;
} */

#market-box #upper-box {
  position: relative;
  height: 485px;
  /*background-image: url("../assets/images/Polaroid.png");*/
  /*da eliminare*/
  /*background-repeat: no-repeat;*/
  /*background-position: center;*/
  /*background-size: 271px;*/
  /*background-color: #E3E3E3;*/
  /*fino a qui*/
}

#market-box #upper-box #img-evidenza {
  width: 100%;
  position: relative;
  height: 485px;
  object-fit: cover;
}

#market-box #upper-box #evidenza-box {
  display: flex;
  justify-content: space-between;
  /* padding: 32px 34px 0 34px; */
  width: 100%;
}

#market-box #upper-box #evidenza-box #grey-box {
  /* height: 48px; */
  background-color: #c7c7c7;
  font-size: 0.63em;
  font-weight: bold;
  margin: 0;
  letter-spacing: $default-letter-spacing;
  padding: 14px;
  border-radius: 7px;
}

#market-box #upper-box #evidenza-box #product-image {
  width: 34px;
}

#market-box #upper-box #descrizione {
  /*position: absolute;*/
  /*bottom: 14px;*/
  /*left: 34px;*/
  position: relative;
  width: 100%;
  height: 248px;
  z-index: -1;
}

#market-box #upper-box #detail-box {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-left: 34px;
  padding-bottom: 34px;
  padding-top: 80px;
  color: white;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 1)
  );
}

#market-box #upper-box #detail-box h3 {
  font-size: 32px;
}

#market-box #upper-box #detail-box p {
  font-size: 25px;
  line-height: 49px;
}

#market-box #label-box {
  width: 100%;
  // height: 107px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  // font-size: 29px;
  font-weight: bold;
}

#market-box #label-box .selected {
  color: black;
  // border-bottom: 2px solid #a31316;
}

#market-box #label-box div {
  width: calc(100% / 2);
  color: rgba(0, 0, 0, 0.4);
  // height: 117px;
  // line-height: 124px;
}

#market-box #sale-box {
  background-color: #f7f7f7;
  padding: $default-padding $default-padding 0;
  background-color: #f7f7f7;
  // margin-bottom: 100px;
  column-width: 120px;
  width: calc(100% - 9px);
  overflow-x: hidden;
}

#market-box #sale-box .item-box:nth-child {
  /*float: left;*/
  /*width: 50%;*/
  /*padding: 12px;*/
  /*position: relative;*/
}

/*#market-box #sale-box .item-box:nth-child(odd) .item {*/

/*  !*width: 100%;*!*/

/*    !*height: 350px;*!*/

/*    !*object-fit: cover;*!*/

/*    border-radius: 12px;*/

/*}*/

#market-box #sale-box .item-box:nth-child(odd) .cuore {
  position: absolute;
  right: 24px;
  top: 24px;
  width: 66px;
}

/*#market-box #sale-box .item-box:nth-child(even) {*/

/*  !*float: right;*!*/

/*  !*width: 50%;*!*/

/*  !*padding: 12px;*!*/

/*  !*position: relative;*!*/

/*}*/

/*#market-box #sale-box .item-box:nth-child(even) .item {*/

/*  !*width: 100%;*!*/

/*    !*height: 470px;*!*/

/*    !*object-fit: cover;*!*/

/*    border-radius: 12px;*/

/*}*/

#market-box #sale-box .item-box:nth-child(even) .cuore {
  position: absolute;
  right: 24px;
  top: 24px;
  width: 66px;
}

// #market-box #sale-box .item {
//   margin: 1px;
// }

/*#market-box #sale-box:after {*/

/*  content: "";*/

/*  clear: both;*/

/*  display: table;*/

/*}*/

// #market-item-container #main-image {
//   position: relative;
// }

#market-item-container #main-image #big-img {
  width: 100%;
  /*padding: 21px 34px 15px 34px;*/
  object-fit: cover;
  height: 44vh;
  border-radius: $default-border-radius;
}

#market-item-container #main-image .more {
  position: absolute;
  top: 60px;
  right: 70px;
  width: 35px;
}

#market-item-container #scrolling-img {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 86px;
  min-height: 86px;
  height: 86px;
  margin: 10px 0;
  #img-container,
  #img-container div,
  #img-container div img {
    height: 100%;
  }
}

#market-item-container #scrolling-img #img-container {
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

#market-item-container #scrolling-img #img-container div {
  margin: 0 10px 0 0;
}

#market-item-container #scrolling-img #img-container div img {
  border-radius: $default-border-radius;
  max-width: none;
}

#market-item-container #scrolling-img #img-container::-webkit-scrollbar {
  display: none;
}

#market-item-container #description-box {
  letter-spacing: $default-letter-spacing;
  font-weight: 500;
  overflow-x: hidden;
}

#market-item-container #description-box #price-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
}

#market-item-container #description-box #price-box p {
  letter-spacing: $default-letter-spacing;
  font-weight: 500;
}

#market-item-container #description-box #price-box img {
  width: 68px;
}

#market-item-container #description-box p {
  font-size: 0.85em;
  letter-spacing: $default-letter-spacing;
  font-weight: 500;
}

#market-item-container #user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#market-item-container #user-info .name {
  width: 100%;
  font-weight: 500;
  padding-left: 16px;
  font-size: 0.95em;
  letter-spacing: 1px;
}

#market-item-container #user-info #overlapping {
  display: flex;
}

#market-item-container #user-info #overlapping div {
  // height: 50px;
  margin-left: -8px;
}

// #market-item-container #user-info #overlapping div img {
//   height: 50px;
// }

// #market-item-container #user-info #overlapping #last-img {
//   background: black;
//   width: 50px;
//   height: 50px;
//   border-radius: 50%;
//   position: relative;
// }

// #market-item-container #user-info #overlapping #last-img small {
//   color: white;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   font-size: 0.95;
// }

#market-item-container #contatti-box {
  display: flex;
  justify-content: space-around;
  margin: 16px 0 0;
}

#market-item-container #contatti-box button {
  // border: 1px solid black;
  width: 100%;
  border-radius: $default-border-radius;
  border: #707070 1px solid;
  // margin: 0 8px;
  text-align: center;
  font-weight: 500;
  background: transparent;
  font-size: 0.95em;
  letter-spacing: $default-letter-spacing;
  // background-color: #607d8b;
  color: white;
  padding: 13px 0;
  &:nth-last-child(1) {
    margin-left: 8px;
  }
}
.item img {
  border-radius: $default-border-radius;
}
.main {
  padding: 0 0 0 0;
}
.empty-market-tablet-image {
  text-align: center;
  margin-bottom: 25px;
}
.plus > img {
  width: 22px;
}
</style>
